import React from "react";

const Terms = () => {
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="common-head">
            <h1>Terms & Conditions</h1>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="group-guideline-desc">
          <div className="desc-space-guide">
            <h5 className="sub-heading mb-4">
              Terms and Conditions of Use Effective Date: 1/27/2021
            </h5>
            <p>
              OUR USE OF AND ACCESS TO OUR SERVICES (DEFINED BELOW) ARE SUBJECT
              TO THE FOLLOWING TERMS. IF YOU DO NOT AGREE TO ALL OF THE
              FOLLOWING, YOU MAY NOT USE OR ACCESS OUR SERVICES IN ANY MANNER.
              If You accept or agree to these Terms and Conditions of Use on
              behalf of a company or other legal entity, You represent and
              warrant that You have the authority to bind that company or other
              legal entity to these Terms and Conditions of Use and, in such
              event, “You” and “Your” will refer and apply to that company or
              other legal entity in addition to You.
            </p>
            <p>
              The purpose of this terms of use agreement (“Terms of Use”) is to
              set forth the terms and conditions under which InTransit Inc.
              and/or its affiliated companies (collectively, “InTransit”, “we”,
              “us” or “our”), make our Internet website (“Site”) and related
              software-as-a-service platform (“Platform”), as well as any
              products and services made available thereon, including but not
              limited to our shipping insurance policies (the “InTransit
              Policy”) and services (collectively, the Site, Platform, InTransit
              Policy, and other products and services made available through the
              Site and Platform, the “Services”) and the content and materials
              available on the Services (the “Content”) available to merchants
              and the conditions under which such merchants may have access to
              and use such Services and Content. Please read these Terms of Use
              carefully before using our Services or Content. By accessing or
              using the Site and/or Services, clicking on a button or taking any
              other action to signify Your acceptance of these Terms of Use, or
              completing our account registration process, You: (1) agree to be
              bound by these Terms and any future amendments and additions to
              these Terms as published from time to time through the Site; and
              (2) represent You are of legal age in Your jurisdiction of
              residence to form a binding contract with InTransit. These Terms
              include the provisions in this document, as well as those in the
              InTransit Privacy Policy and the InTransit SMS Policy. These terms
              also include the provisions (including any exclusions and
              limitations) of InTransit’s marine cargo policy, a summary of
              which can be found at https://InTransit.com/insurance/. Your use
              of, and participation in, certain Services may be subject to
              additional terms (“Supplemental Terms”) and such Supplemental
              Terms will either be listed in the Terms of Use or will be
              presented to You for Your acceptance when You sign up to use the
              supplemental Service. If the Terms of Use are inconsistent with
              the Supplemental Terms, the Supplemental Terms shall control with
              respect to such Service. The Terms of Use and any applicable
              Supplemental Terms are referred to herein as the “Agreement.”
              These Terms of Use include the provisions in this document, as
              well as those in the InTransit Privacy Policy. InTransit may
              modify these Terms of Use at any time from time to time without
              prior notice and such modification shall be effective: (1) for
              Users who first use the Site affected by such modification after
              the posting, upon posting by InTransit on the Website or (2) for
              existing Users, thirty (30) days after posting by InTransit on the
              Website. If You do not agree to the modification, You must cease
              Your use of the Website immediately and Your only recourse is to
              cease using the Services. See our current Privacy Policy for
              information and notices regarding our collection and use of
              personal information, found at https://InTransit.com/privacy/.
              InTransit reserves the right to update and upgrade our product
              offerings in our sole discretion, including, without limitation,
              the “InTransit widget” and “InTransit asset.”
            </p>
            <p>
              Use of Services and Content InTransit develops and makes available
              to You applications designed to enhance Your e-commerce platform
              or, if You are a consumer, Your online shopping experience. Our
              software applications are built as an add-on to a merchant’s
              existing online storefront, offering value-added features. Through
              our software applications, merchants can offer consumers the
              opportunity to add their shipments to the InTransit Policy (as
              described in the “Insurance” section below). InTransit provides
              software that allows consumers to file a notice of loss and to
              track the location of their shipments. Upon an election to protect
              their shipments under the InTransit Policy, consumers will receive
              a link to file such notices of loss and to track such shipments.
              In order to access certain features of the Site and Services, You
              may be required to register an Account (as defined below) and
              become a Registered User. For the purposes of this Agreement, a
              “Registered User” is a User who has registered for any Account.
              When registering an account for the Services (“Account”), You
              agree to provide only true, accurate, current and complete
              information requested by the registration form (the “Registration
              Data”) and to promptly update the Registration Data thereafter as
              necessary to keep it current. You represent that You are not
              barred from using the Services under any applicable law and that
              You will be responsible for all activities that occur under Your
              Account. You may not authorize any third party (other than, if
              applicable, the employees, consultants or agents of the corporate
              member You represent) to access or use our Services on Your
              behalf. You are responsible for maintaining the confidentiality of
              the user ID and password, and are fully responsible for all
              activities that occur under Your user ID or password. You agree to
              immediately notify us of any unauthorized use of Your user ID or
              password or any other breach of security. We cannot and will not
              be liable for any loss or damage arising from any unauthorized use
              of Your account. You acknowledge and agree that You have no
              ownership or other property interest in Your Account and that all
              rights in and to Your Account are owned by and inure to the
              benefit of InTransit. Except as otherwise indicated, our Services
              and Content, and all rights thereto, are the property of InTransit
              and/or our affiliated companies and are protected under U.S.
              copyright, trade secret, trademark and patent law as well as
              international treaty provisions, with all rights reserved.
              InTransit App and other related graphics, logos, service marks and
              trade names used on or in connection with the Services are the
              trademarks of InTransit App Inc. and may not be used without
              permission in connection with any third-party products or
              services. Other trademarks, service marks and trade names that may
              appear on or in the Services are the property of their respective
              owners. Subject to these Terms of Use, InTransit grants You a
              limited license to install and use the Services solely for the
              purpose of operating Your online store. Any future release,
              update, or other addition to the Services and/or Content shall be
              subject to these Terms of Use. InTransit, its suppliers, and its
              service providers reserve all rights not granted in Terms of Use.
            </p>
            <p>
              Restrictions on Use of the Services Except as authorized herein or
              with our prior written approval, You are prohibited from copying,
              modifying, displaying, distributing, transmitting, transferring,
              redelivering, publishing, selling, marketing, renting, leasing,
              licensing or sublicensing, creating derivative works, or otherwise
              using or making available to any third party/parties any of our
              Services or any of the Content for any purpose. Systematic
              retrieval of data from any of our Services or the Content thereon
              to create or compile, directly or indirectly, a collection,
              compilation, database or directory, unless with our express
              written permission, is prohibited. You agree that You will not,
              directly or indirectly, reverse engineer, decompile, reproduce or
              otherwise attempt to derive source code, trade secrets, or other
              intellectual property from any information, material, or
              technology included on any of our Services or in the Content. Any
              attempt to do so is a violation of our rights, and if You breach
              this restriction, You may be subject to prosecution and damages.
              Finally, You are strictly prohibited from accessing and/or using
              the Services or any Content to develop, or have a third party
              develop, a product or service that is similar or competitive to
              the Services, including but not limited to any product or service
              that offers or makes available shipping insurance to its
              customers.
            </p>
            <p>
              Additional Restrictions Without limiting the application of
              anything herein to commercial and business users, if You use the
              Services for commercial or business purposes, You are subject to
              the following restrictions: At all times during the Term and
              thereafter for a period of twenty four (24) months, You will not
              for any reason, whether directly or indirectly, (i) solicit,
              recruit, or encourage any InTransit customer, employee, or
              consultant to reduce, alter, or terminate its relationship with
              InTransit or (ii) divert any potential InTransit customer away
              from InTransit. InTransit shall be Your exclusive provider of any
              service and/or software that enables You to offer consumer-facing
              shipping insurance, protection, warranty, or similar offering
              (collectively and individually, “Shipping Protection”), unless the
              merchandize covered by such Shipping Protection is considered to
              be a policy exclusion. At all times during the Term and thereafter
              for a period of twenty four (24) months, You and Your subsidiaries
              and affiliates covenant and agree that You shall not provide
              Shipping Protection of any kind to any party unless You or Your
              affiliates obtain all necessary and required licenses and permits
              for such offering from all relevant federal and state agencies and
              regulatory bodies. You acknowledge that a breach or threatened
              breach of this paragraph may give rise to irreparable harm to
              InTransit, for which monetary damages may not be an adequate
              remedy, and You hereby agree that in the event of a breach or a
              threatened breach by You or Your subsidiaries or affiliates of any
              such obligations, InTransit shall, in addition to any and all
              other rights and remedies that may be available to it in respect
              of such breach, be entitled to seek equitable relief, including a
              temporary restraining order, an injunction, specific performance
              and other relief that may be available from a court of competent
              jurisdiction (without any requirement to post bond).At all times
              during the Term and thereafter, neither Party will, whether
              directly or indirectly, make any disparaging, negative, or false
              or misleading statements with respect to the other Party.
              Notwithstanding the foregoing, nothing in this paragraph shall
              prohibit a Party from providing truthful information pursuant to
              the order or requirement of a court, administrative agency, or
              other governmental body; provided, however, that prior to
              providing such information, a Party shall provide prompt notice of
              such court order or requirement to the other Party to enable such
              Party to seek a protective order or otherwise prevent or restrict
              such disclosure.
            </p>
            <p>
              Insurance A summary of the InTransit Policy (InTransit’s cargo
              insurance policy) can be found at
              https://go.InTransit.com/hubfs/Download%20Files/InTransit%20Insurance%20Policy.pdf.
              InTransit Shipping Protection is subject to and strictly limited
              by the terms of the InTransit Policy. In order for InTransit to
              extend shipping protection to a consumer, InTransit’s licensed
              producer (Safe Order Solutions, LLC) procures a cargo insurance
              policy from a licensed insurance broker via authorized insurance
              underwriters (“the Underwriters”) and the Underwriters designate
              InTransit as the named insured. The Policy extends coverage to
              online purchases that are lost or damaged while in transit or
              “porch pirated” (meaning the carrier reports the status as
              “delivered” but the parcel has been stolen from the delivery
              address and a police report has been filed) where the
              transportation of such purchases is tracked through InTransit.
              InTransit’s offer of shipping protection is not intended to
              provide insurance to You or Your customers directly, and neither
              You nor Your customers are an insured or an additional insured
              under the Policy (the foregoing being, collectively, “InTransit
              Shipping Protection”). Merchants cannot file a claim on behalf of
              a customer unless specifically requested by that customer.
              InTransit may require evidence of the customer’s request before
              processing the claim. As a merchant, upon addition of Your billing
              information to Your InTransit Account, a widget will go live on
              Your website. InTransit reserves the right to change its pricing
              at any time. If Your customers opt into InTransit Shipping
              Protection, this charge will appear for such customers to review
              and verify at checkout. The InTransit Platform may, from time to
              time at InTransit’s sole discretion, test cost variances to
              identify the optimal conversion rate. Upon Your agreement to these
              Terms, the InTransit Platform and access to the Policy will be
              activated on Your site. As a customer of a merchant that offers
              InTransit Shipping Protection, Your election to add packages to
              the InTransit Policy is entirely optional. You have the option of
              obtaining protection from an alternative source or not at all.
            </p>
            <p>
              If You elect to add packages to the InTransit Policy, InTransit
              will provide You with a link to a summary of the InTransit Policy
              and instructions to file a notice of loss. The Policy does not
              cover the following without a specific written amendment from
              InTransit (collectively the “Policy Exclusions”): Automobiles and
              Motorcycle; Glass windows, plate glass and similar goods; Bagged
              Goods; Jewelry (valued in excess of $2500); Boats & Yachts; Live
              Animals; Cass; Lumber; Ceramic, marble or granite tiles, slab
              blocks, countertops or statues; Negotiable Papers; Cigarettes and
              Other Tobacco Products; Perishable Commodities; Computer memory
              modules & Cards; Pharmaceutical Drugs; Cotton; Precious Stones and
              Metals; Fine Arts (valued in excess of $10,000 per piece); Scrap
              Metal; Steel Metal and Steel Metal Products; Flowers; Securities;
              Fresh foods (excepting frozen beef and pork in refrigerated
              containers); Used Household Goods and Personal Effects. InTransit
              is not liable for more than $250,000 for any one vessel or
              conveyance per any one account of the Assured, except that in the
              following cases, this insurance shall not cover more than: $5,000
              any one package or shipment, $2,500 any one package or shipment
              containing a laptop or tablet computer, mobile/smart phone or
              watch (“Shipping Protection Limit”). Any shipments that exceed
              InTransit’s Shipping Protection Limit will not be covered by
              InTransit Shipping Protection. If for any reason payments are
              billed/collected for shipments that exceed the Shipping Protection
              Limit, the excess amount will be returned to the subscriber.
              InTransit Shipping Protection attaches from the time the covered
              goods commence transit and/or are located anywhere incidental to
              transit and continues during the ordinary course of transit until
              transportation terminates at final destination or the assured’s
              interest ceases, whichever occurs first. All fees paid for the
              Services are non-refundable and non-transferable except as may be
              expressly provided in these Terms. You may cancel the Services at
              any time at no charge simply uninstall the Services You no longer
              want to use, and InTransit will cease providing the Services to
              You. Claims for packages marked “delivered must be filed after 5
              days and before 15 days from the date the package was marked
              “delivered.” Claims for packages presumed to be lost (where the
              status is not “delivered”) must be filed after 7 days (20 for
              international) and within 30 days from the last checkpoint. Should
              the claim be approved by the Underwriters, it will be deemed to be
              in full settlement and satisfaction of all claims and demands by
              the customer (inclusive of individual consumers and merchants, the
              “Claimant”). In consideration of this payment, the Claimant does
              hereby release and discharge the Underwriters, InTransit, and each
              of their respective principals, executives, agents, employees,
              representatives, successors, assigns, subsidiaries, and affiliated
              companies, from any and all further claims existing and/or arising
              in the future relating to the above-referenced merchandise. The
              Claimant further guarantees that it is the person or entity
              entitled to payment and agrees that Underwriters are subrogated to
              all of the claimant’s rights of recovery on account of any and all
              loss or damage from the carriers and from any other persons or
              corporations. The Claimant agrees to cooperate with and to assist
              the Underwriters and InTransit in effecting such recovery, to
              include providing all documentation or other information which may
              be needed by Underwriters and/or InTransit; and to execute in the
              customer’s name any documents which may be necessary to carry into
              effect the purpose of this agreement. In exchange for this claim
              payment, the Claimant agrees that any monies collected from any
              such carrier, vessel, person or corporation, whether received in
              the first instance by the Claimant or by the Underwriters or
              InTransit, shall be the property of Underwriters; and that the
              acceptance of this claim payment shall not prejudice or take away
              any rights or remedies which Underwriters would otherwise have by
              virtue of such payment.
            </p>
            <p>
              This text messaging services may not be available on all wireless
              carriers. Messages are currently supported on all major carriers
              including but not limited to AT&T, Boost Mobile, T-Mobile, Metro
              PCS, Verizon Wireless, Sprint, U.S. Cellular, Cricket, and Virgin
              Mobile. InTransit may add or remove any wireless carrier from this
              program without notice. Mobile access and text message delivery is
              subject to your mobile carrier’s network availability. Such access
              and delivery is not guaranteed. Neither mobile carriers nor
              InTransit are liable for delayed or undelivered messages
            </p>
            <p>
              Alphabet (Google/Android) Specific Terms and Conditions In
              addition to Your agreement with the foregoing terms and
              conditions, You acknowledge and agree to the following provisions
              with respect to Your use of the Android compatible version of the
              licensed mobile application (also called the “Licensed
              Application”). This Licensed Application is an agreement between
              You and us. Alphabet Inc. (“Alphabet”) is not a party to these
              Terms and does not own and is not responsible for the Licensed
              Application. Alphabet is not providing any warranty for the
              Licensed Application, except if applicable, to refund the purchase
              price for it. Alphabet is not responsible for maintenance or other
              support services for the Licensed Application and shall not be
              responsible for any other claims, losses, liabilities, damages,
              costs or expenses with respect to the Licensed Application,
              including, without limitation, any third party product liability
              claims, claims that the Licensed Application fails to conform to
              any applicable legal or regulatory requirement, claims arising
              under consumer protection or similar legislation, and claims with
              respect to intellectual property infringement. Any inquiries or
              complaints relating to the use of the Licensed Application,
              including those pertaining to intellectual property rights, must
              be directed to us at the address provided in the ‘Contact Us’
              section of the Licensed Application. The license You have been
              granted herein is non-exclusive, worldwide, and perpetual to
              perform, display, and use the Licensed Application on the device.
              In addition, You agree to comply with the terms of any third party
              agreement that is applicable to You when using the Licensed
              Application, such as Your wireless data service agreement. You
              hereby represent and warrant (i) You are not located in a country
              that is subject to a U.S. Government embargo, or that has been
              designated by the U.S. Government as a “terrorist supporting”
              country; and (ii) You are not listed on any U.S. Government list
              of prohibited or restricted parties. You acknowledge and agree
              that Alphabet and Alphabet’s subsidiaries are third party
              beneficiaries of these Terms and that, upon Your acceptance of the
              terms and conditions of these Terms, Alphabet will have the right
              (and will be deemed to have accepted the right) to enforce these
              Terms You as a third party beneficiary thereof. Alphabet, Google,
              Google Play, Android and other marks are trademarks of Alphabet
              Inc., registered in the U.S. and other countries.
            </p>
            <p>
              For further information, please contact us at{" "}
              <a href="mailto:support@InTransit.com">support@InTransit.com</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
